module.exports = {"610727001":"兴州街道","610727002":"横现河街道","610727101":"接官亭镇","610727102":"西淮坝镇","610727103":"两河口镇","610727104":"金家河镇","610727105":"徐家坪镇","610727106":"白水江镇","610727107":"硖口驿镇","610727108":"马蹄湾镇","610727109":"乐素河镇","610727110":"郭镇","610727111":"黑河镇","610727112":"白雀寺镇","610727113":"仙台坝镇","610727114":"五龙洞镇","610727115":"观音寺镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610727.json
// module id = 2645
// module chunks = 0